import ls from 'local-storage';

export default {
  get: key => ls.get(key),
  set: (key, value) => typeof value !== 'undefined' && ls.set(key, value),
  remove: key => ls.remove(key),
};
